module.exports = __webpack_public_path__ + "fonts/Muli-Regular.89ecae1e.ttf";